import { BaseBodyMath } from "./BaseBodyMath.js";
import { kAU } from "../AstroConstants.js";
import { BodyMeanEquatorFrame, J2000EclipticFrame, J2000EquatorFrame, } from "../ReferenceFrame.js";
import { Vector3 } from "../../math/Vector3.js";
import { Quaternion } from "../../math/Quaternion.js";
export class BodyMath extends BaseBodyMath {
    static EquatorFrame = new J2000EquatorFrame();
    static EclipticFrame = new J2000EclipticFrame();
    _orbit;
    constructor(orbit, rotation, bodyFrame, parent) {
        super(rotation, bodyFrame, parent ? new BodyMeanEquatorFrame(parent) : bodyFrame);
        this._orbit = orbit;
        //BaseBodyMath
        this.orbitPeriod = this._orbit.getPeriod();
        this.orbitSize = this._orbit.getBoundingRadius() * kAU;
    }
    getPosition(jd) {
        let position = this._orbit.positionAtTime(jd);
        position = position.multiplyByFloat(kAU);
        const orbitFrame = this._orbitFrame.getOrientation(jd);
        position = Vector3.MultiplyQuaternionByVector3(Quaternion.Inverse(orbitFrame), position);
        position.x = -position.x;
        return position;
    }
}
